<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Dedication Page" epub:type="dedication" role="doc-dedication">
<p class="DED">To my late mother, Barbara Rusbridger, who forced me to practise and who told me that music would lead to friendship. She was right.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?087afde6